<template>
  <van-dialog
    :show="showNotify"
    confirm-button-color="#007AFF"
    class="fail-tv360-dialog"
    :show-confirm-button="false"
  >
    <template #title>
      <div class="fail-tv360-dialog__icon">
        <img src="@/static/icon-warning.svg" alt="warning" />
      </div>
      <div class="fail-tv360-dialog__title">
        {{ title || $t("tv360.account_required") }}
      </div>
    </template>
    <template #default>
      <div class="fail-tv360-dialog__description">
        {{ message || $t("tv360.account_required_desc") }}
      </div>
    </template>
    <template #footer>
      <div class="fail-tv360-dialog__buttons">
        <van-button
          @click="handleClose()"
          class="fail-tv360-dialog__btn fail-tv360-dialog__btn--close"
        >
          {{ $t("close") }}
        </van-button>
      </div>
    </template>
  </van-dialog>
</template>

<script>
import { Dialog, Button } from "vant";

export default {
  name: "FailTV360Dialog",
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
  },
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
  watch: {
    isShow(value) {
      this.showNotify = value;
    },
  },
  mounted() {
    this.showNotify = this.isShow;
  },
  data() {
    return {
      showNotify: false,
    };
  },
  created() {
    this.showNotify = this.isShow;
  },
  methods: {
    handleClose() {
      this.showNotify = false;
      this.$emit("update:isShow", false);
    },
    handleSignUp() {
      this.showNotify = false;
      this.$emit("update:isShow", false);
      this.$emit("sign-up");
    },
  },
};
</script>

<style lang="scss">
.fail-tv360-dialog {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 16px;
  width: 90vw !important;
  //max-width: 400px;

  .fail-tv360-dialog__icon {
    display: flex;
    justify-content: center;
    padding-top: 0px;
    padding-bottom: 6px;

    img {
      width: 48px;
      height: 48px;
    }
  }

  .fail-tv360-dialog__title {
    color: #000;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    padding: 0 16px 0px 16px;
  }

  .fail-tv360-dialog__description {
    color: #667085;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.078px;
    padding: 0 24px 0px 24px;
  }

  .fail-tv360-dialog__buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 24px;
    gap: 8px;

    .fail-tv360-dialog__btn {
      flex: none;
      min-width: 120px;
      padding: 0 24px;
      height: 30px;
      border-radius: 22px;
      font-size: 14px;
    }

    .fail-tv360-dialog__btn--close {
      background: #b81627;
      color: #fff;
      border: none;
    }

    .fail-tv360-dialog__btn--signup {
      background: #b81627;
      color: #fff;
      border: none;
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    }
  }
}
</style>
